export const socialLinks = {
  twitter: "https://twitter.com/thefunny_ones",
  instagram: "https://www.instagram.com/the.funny1s/",
  tiktok: "https://www.tiktok.com/@funnyzedbhx",
};
